import type { IconData } from '@stacksjs/iconify-core'

export const beerPitch: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M35 21h2.42c2.83 0 5.255 1.988 5.452 4.81a53 53 0 0 1 0 7.38C42.675 36.012 40.251 38 37.42 38H35m-5-17a7 7 0 1 0-2.276-13.622A9 9 0 0 0 20 3a9 9 0 0 0-7.724 4.378A7 7 0 1 0 10 21h.002c.005 1.065.018 1.99.034 2.784C10.087 26.112 11.671 28 14 28s3.915-1.888 3.963-4.216c.018-.85.031-1.625.036-2.784z\"/><path d=\"M34.71 19.179c.163 2.297.29 5.48.29 9.821c0 3.287-.109 5.909-.268 7.986c-.358 4.67-3.893 7.735-8.575 7.91c-1.685.063-3.719.104-6.157.104s-4.472-.041-6.157-.104c-4.682-.175-8.216-3.24-8.575-7.91C5.11 34.909 5 32.286 5 29c0-4.342.127-7.524.29-9.821\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default beerPitch
